import { useMemo } from 'react';

import { useLoggedInEmployeeId } from '~/components/Auth';
import {
  UseSelectedEmployeeDetailsOutput,
  useSelectedEmployeeDetails,
} from '~/hooks/employee/useSelectedEmployeeDetails';
import { useSyncedLocalStorage } from '~/hooks/useLocalStorage';

export type UseSelectedEmployeeIdStateOutput = {
  selectedEmployeeId: number;
  setSelectedEmployeeId: (employeeId: number) => void;
  isSelectedEmployeeLoggedInUser: boolean;
  refreshSelectedEmployeeId: () => void;
  isLoading: boolean;
  selectedEmployeeDetails: UseSelectedEmployeeDetailsOutput;
};

export const useSelectedEmployeeIdState =
  (): UseSelectedEmployeeIdStateOutput => {
    const loggedId = useLoggedInEmployeeId();

    // Local Storage
    const {
      value: selectedEmployeeId,
      setValue: setSelectedEmployeeId,
      refresh: refreshSelectedEmployeeId,
      isLoading: isLoadingLocalStorage,
    } = useSyncedLocalStorage('selectedEmployeeId', loggedId);

    const { isSelectedEmployeeLoggedInUser } = useMemo(() => {
      return {
        isSelectedEmployeeLoggedInUser: selectedEmployeeId === loggedId,
      };
    }, [selectedEmployeeId, loggedId]);

    const selectedEmployeeDetails = useSelectedEmployeeDetails({
      employeeId: selectedEmployeeId,
    });

    return {
      selectedEmployeeId,
      setSelectedEmployeeId,
      isSelectedEmployeeLoggedInUser,
      refreshSelectedEmployeeId,
      selectedEmployeeDetails,
      isLoading:
        isLoadingLocalStorage ||
        selectedEmployeeDetails.isLoading ||
        !selectedEmployeeDetails.isDataInSync,
    };
  };
